import { Controller } from "@hotwired/stimulus"
import { TempFormHelper } from "~/helpers/temp_form_helper"
import "@selectize/selectize"

// This controller is used to add the selected or currently filtered leads to an existing campaign.
// It also allows to add a single lead to a campaign by passing lead-id param when calling show method.
export default class extends Controller {
  static get targets() {
    return ["modal", "campaignInput"]
  }

  static get values() {
    return {
      filters: { type: Object, default: {} },
      filtersType: String,
      outreachEnabled: Boolean,
      selectedLeadIds: { type: Array, default: [] },
      singleLeadId: Number
    }
  }

  connect() {
    if (this.hasCampaignInputTarget) {
      this.campaignSelectize = $(this.campaignInputTarget).selectize({})
    }
  }

  disconnect() {
    // Destroy the Selectize element to avoid duplication of the field
    if (this.campaignSelectize !== undefined) {
      this.campaignSelectize[0].selectize.destroy()
    }
  }

  // This action shows the modal if the preconditions are met.
  show(event) {
    let leadId = event.params.leadId
    if (leadId) {
      this.singleLeadIdValue = leadId
    } else {
      this.singleLeadIdValue = null
    }

    if (!this.outreachEnabledValue) {
      App.displayFlash("danger", i18n.t("js.back.lead_actions.connect_google_account_html"))
      return
    }

    if (this.selectedLeadIdsValue.length === 0 && Object.keys(this.filtersValue).length === 0 && !this.singleLeadIdValue) {
      if (this.filtersTypeValue === "engagement") {
        App.displayFlash("danger", i18n.t("js.back.lead_actions.filter_or_select_recipients_to_a_campaign"))
      } else {
        App.displayFlash("danger", i18n.t("js.back.lead_actions.filter_or_select_leads_to_a_campaign"))
      }

      return
    }

    if (this.hasFiltersValue && this.filtersValue.email === "~") {
      App.displayFlash("danger", i18n.t("js.back.lead_actions.email_blank_filter_is_not_allowed_to_a_campaign"))
      return
    }

    new bootstrap.Modal(this.modalTarget).show()
  }

  // This action submits a temporary form to add the selected or filtered leads to the campaign selected in the modal.
  submit(event) {
    event.target.disabled = true
    event.target.innerHTML = `<div class='far fa-spinner-third fa-spin'></div> ${i18n.t("js.back.lead_actions.adding")}`

    App.displayFlash("success", i18n.t("js.back.lead_actions.adding_to_campaign"))

    TempFormHelper.create(`/campaigns/${this.campaignInputTarget.value}/audience`, "put", (form) => {
      if (this.singleLeadIdValue) {
        TempFormHelper.addHiddenInput(form, "filters_type", "leads")
        TempFormHelper.addHiddenInput(form, "campaign[leads_filters][id][]", this.singleLeadIdValue)
        this.singleLeadIdValue = null
      } else if (this.selectedLeadIdsValue.length > 0) {
        TempFormHelper.addHiddenInput(form, "filters_type", "leads")
        this.selectedLeadIdsValue.forEach(leadId => {
          TempFormHelper.addHiddenInput(form, "campaign[leads_filters][id][]", leadId)
        })
      } else if (this.filtersTypeValue == "leads") {
        TempFormHelper.addHiddenInput(form, "filters_type", "leads")

        for (const [key, value] of Object.entries(this.filtersValue)) {
          if (key !== "" && value !== "") {
            TempFormHelper.addHiddenInput(form, `campaign[leads_filters][${key}]`, value)
          }
        }
      } else if (this.filtersTypeValue == "engagement") {
        TempFormHelper.addHiddenInput(form, "filters_type", "engagement")

        for (const [key, value] of Object.entries(this.filtersValue)) {
          if (key !== "" && value !== "") {
            TempFormHelper.addHiddenInput(form, `campaign[engagement_filters][${key}]`, value)
          }
        }
      }
    }).submit()
  }

  // This action is used to update the selected leads value.
  // We trigger this using the check-all controller.
  updateSelection(event) {
    if (event.detail.allSelected) {
      this.selectedLeadIdsValue = []
    } else if (event.detail.dataSets) {
      this.selectedLeadIdsValue = event.detail.dataSets.map(dataSet => dataSet.leadId || dataSet.recordId).filter(Boolean)
    } else {
      this.selectedLeadIdsValue = []
    }
  }
}
